import { useState as p } from "react";
function f({
  onChange: t,
  maxLength: s,
  showRemainingChars: e,
  type: u
}) {
  const [n, c] = p(
    s || 0
  ), a = !!(e && s && (u === "text" || u === "password"));
  return {
    hasRemainingCharsCount: a,
    handleInputChange: (r) => {
      if (!a)
        return t == null ? void 0 : t(r);
      const { value: l } = r.target, i = l.replace(/\s{2,}/g, " ").trimStart(), o = i.length || 0;
      return c(s - o), r.target.value = i, t == null ? void 0 : t(r);
    },
    remainingCharsCount: n
  };
}
export {
  f as useRemainingCharsCount
};
